<template>
  <div class="carrousel-wrapper">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333; width: 100%;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        caption="Pièces de rechange"
        text="La commercialisation des pièces de rechange est une activité essentielle pour les entreprises qui fournissent des produits nécessitant un entretien ou des réparations."
        :img-src="require('@/assets/img/img7.jpg')"
      ></b-carousel-slide>

      <b-carousel-slide
        caption="Équipements de balisage lumineux pour aéroports"
        text="Fourniture, installation et mise en service des équipements du balisage lumineux des aéroports"
        :img-src="require('@/assets/img/img8.jpg')"
      ></b-carousel-slide>

      <b-carousel-slide
        caption="Formation et Conseil"
        text="La formation et le conseil dans la maintenance des bus et camions sont des services clés pour garantir la sécurité et la fiabilité des véhicules."
        :img-src="require('@/assets/img/img9.jpg')"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>
<style scoped>
.carrousel-wrapper {
  width: 100%;
  overflow: hidden;
  border-radius: 22px;
  background: #fff;
}

#carousel-1 {
  border-radius: 22px;
  overflow: hidden;
}

#carousel-1 >>> img {
  width: 100%;
  height: 420px;
  object-fit: cover;
}

#carousel-1 >>> .carousel-inner {
  border-radius: 22px;
}

#carousel-1 >>> .carousel-caption {
  left: 50%;
  right: auto;
  bottom: 28px;
  transform: translateX(-50%);
  width: calc(100% - 64px);
  max-width: 780px;
  padding: 24px 28px;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.14) 0%, rgba(17, 24, 39, 0.68) 100%);
  backdrop-filter: blur(6px);
}

#carousel-1 >>> .carousel-caption h3 {
  margin-bottom: 10px;
  font-size: 32px;
  font-weight: 700;
  color: #ffffff !important;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.42);
}

#carousel-1 >>> .carousel-caption p {
  margin: 0;
  font-size: 15px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.96) !important;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.34);
}

#carousel-1 >>> .carousel-indicators {
  bottom: 18px;
}

#carousel-1 >>> .carousel-indicators li {
  width: 28px;
  height: 6px;
  border-radius: 999px;
}

@media (max-width: 768px) {
  .carrousel-wrapper {
    border-radius: 18px;
  }
  #carousel-1 >>> img {
    height: 280px;
  }
  #carousel-1 >>> .carousel-caption {
    width: calc(100% - 24px);
    bottom: 14px;
    padding: 14px 16px;
    border-radius: 16px;
  }
  #carousel-1 >>> .carousel-caption h3 {
    font-size: 20px;
    margin-bottom: 6px;
  }
  #carousel-1 >>> .carousel-caption p {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  #carousel-1 >>> img {
    height: 220px;
  }
  #carousel-1 >>> .carousel-caption {
    display: none;
  }
}
</style>
